import { Game } from '../games/game';
import { PaginationMeta } from './pagination';
import { SSOLink } from './sso-link';

export interface ProductBase {
  slug: string;
  name: string;
  title?: string;
  visible?: boolean;
  active?: boolean;
  updatedAt?: Date;
  publishedAt?: Date;
  productType?: ProductType;
  subType?: string;
  productPerimeterSlug?: string; // this is not store in database ! Only set dynamically
  demo?: boolean;
  shareInProgress?: boolean;
  threadSlug?: string;
  ssoLink?: SSOLink | null;
}

export enum ProductType {
  LEARNIZ = 'learniz',
  GAME = 'game',
  COURSIZ = 'coursiz',
  SCORM = 'scorm',
  SURVEY = 'survey',
  SMART_SEQUENCE = 'smart-sequence',

  // todo should : attachment and section are not really products in front, only used in coursiz sub-types
  ATTACHMENT = 'attachment',
  SECTION = 'section',
  CLASSIZ = 'classiz',
}

export enum ProductGraphicPreferenceStatus {
  DEFAULT = 'default',
  CUSTOM = 'custom',
}

export enum ProductSoundPreferenceStatus {
  DEFAULT = 'default',
  CUSTOM = 'custom',
}

/**
 * config & configDraft are usually rename in different context
 */
export interface Product<T> extends ProductBase {
  config: T;
  configDraft: T;
}

export interface ProductList<T = any> {
  products: ProductListItem<T>[];
  meta: PaginationMeta;
}

export type ProductListItem<S = any> = S & ProductBase; // S as some specific properties of different entities
// in project:
//  - LearnizEdited = ProductBase & { learnizData: LearnizModel }
//  - GameEdited = ProductBase & { gameData: GameData, gameType: Game }

export interface ProductEdited<T = any> extends ProductBase {
  data: T;
  hasConfigDraft?: boolean;
}

export interface ProductResponse<T> {
  slug: string;
  name: string;
  config: T;
  configDraft?: T;
  visible: boolean;
  updatedAt: Date;
  publishedAt: Date;
  productType: ProductType;
  active: boolean;
  subType?: Game;
  documents: string[];
}

/*lightweight product (any type: coursiz/classiz/learniz/game/scorm*/
export interface ProductLighten {
  title: string;
  name: string;
  slug: string;
  productType: string;
}

export interface ProductExplorer {
  title: string;
  name: string;
  slug: string;
  createdAt: string;
  productType: ProductType;
  background: string;
  subType?: Game;
  parentFolderSlug?: string;
  updatedAt?: string;
  publishedAt?: string;
}

export interface DocumentsFields {
  slug: string;
  name: string;
  description?: string;
  source?: string;
}

export interface SubAction {
  productSlug: string;
  coursizParentSlug?: string;
  productParentName?: string;
}

export type NodePickType = 'name' | 'productSlug' | 'taskType';
export type ProductsListPickType = 'name' | 'productType' | 'slug' | 'title';
